module.exports = __webpack_public_path__ + "img/success.37cc1ac9.png";